import { Injectable, signal } from '@angular/core';

export type DialogArt = 'frage' | 'warnung' | 'fehler' | 'info' | 'erfolg';

export interface DialogAnfrage {
  art: DialogArt;
  titel: string;
  text: string;
  jaText: string;
  neinText: string | null;
  aufloesen: (ja: boolean) => void;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly offen = signal<DialogAnfrage | null>(null);

  frage(text: string, titel = 'Bitte bestätigen', jaText = 'Ja', neinText = 'Nein'): Promise<boolean> {
    return this.oeffnen('frage', titel, text, jaText, neinText);
  }

  warnung(text: string, titel = 'Achtung', jaText = 'Fortfahren', neinText = 'Abbrechen'): Promise<boolean> {
    return this.oeffnen('warnung', titel, text, jaText, neinText);
  }

  async fehler(text: string, titel = 'Fehler'): Promise<void> {
    await this.oeffnen('fehler', titel, text, 'OK', null);
  }

  async info(text: string, titel = 'Hinweis'): Promise<void> {
    await this.oeffnen('info', titel, text, 'OK', null);
  }

  async erfolg(text: string, titel = 'Erledigt'): Promise<void> {
    await this.oeffnen('erfolg', titel, text, 'OK', null);
  }

  schliessen(ja: boolean): void {
    const anfrage = this.offen();
    this.offen.set(null);
    anfrage?.aufloesen(ja);
  }

  private oeffnen(art: DialogArt, titel: string, text: string, jaText: string, neinText: string | null): Promise<boolean> {
    this.schliessen(false);
    return new Promise<boolean>((aufloesen) => this.offen.set({ art, titel, text, jaText, neinText, aufloesen }));
  }
}
